module.exports = __webpack_public_path__ + "img/logo-white.9a038b2a.png";